__turbopack_context__.v({
  "addMemeReferenceDisplay": "Rememes-module-scss-module__xxjSQW__addMemeReferenceDisplay",
  "addMemeReferenceDisplayBtn": "Rememes-module-scss-module__xxjSQW__addMemeReferenceDisplayBtn",
  "addMemeReferenceDisplayBtnDisabled": "Rememes-module-scss-module__xxjSQW__addMemeReferenceDisplayBtnDisabled",
  "addMemeReferenceWrapper": "Rememes-module-scss-module__xxjSQW__addMemeReferenceWrapper",
  "addMemeReferencesDropdown": "Rememes-module-scss-module__xxjSQW__addMemeReferencesDropdown",
  "addRememeChecklist": "Rememes-module-scss-module__xxjSQW__addRememeChecklist",
  "addRememeContainer": "Rememes-module-scss-module__xxjSQW__addRememeContainer",
  "addRememeTokenList": "Rememes-module-scss-module__xxjSQW__addRememeTokenList",
  "buttonIcon": "Rememes-module-scss-module__xxjSQW__buttonIcon",
  "connectWalletButton": "Rememes-module-scss-module__xxjSQW__connectWalletButton",
  "formInput": "Rememes-module-scss-module__xxjSQW__formInput",
  "globeIcon": "Rememes-module-scss-module__xxjSQW__globeIcon",
  "linkIcon": "Rememes-module-scss-module__xxjSQW__linkIcon",
  "loader": "Rememes-module-scss-module__xxjSQW__loader",
  "loaderSlot": "Rememes-module-scss-module__xxjSQW__loaderSlot",
  "marketplace": "Rememes-module-scss-module__xxjSQW__marketplace",
  "marketplaceRememe": "Rememes-module-scss-module__xxjSQW__marketplaceRememe",
  "memeRefDropdown": "Rememes-module-scss-module__xxjSQW__memeRefDropdown",
  "metadataTable": "Rememes-module-scss-module__xxjSQW__metadataTable",
  "metadataTableBreak": "Rememes-module-scss-module__xxjSQW__metadataTableBreak",
  "metadataTableNoBreak": "Rememes-module-scss-module__xxjSQW__metadataTableNoBreak",
  "rememesFiltersRow": "Rememes-module-scss-module__xxjSQW__rememesFiltersRow",
  "replica": "Rememes-module-scss-module__xxjSQW__replica",
  "tabActive": "Rememes-module-scss-module__xxjSQW__tabActive",
  "tabFocus": "Rememes-module-scss-module__xxjSQW__tabFocus",
  "unverifiedIcon": "Rememes-module-scss-module__xxjSQW__unverifiedIcon",
  "userLink": "Rememes-module-scss-module__xxjSQW__userLink",
  "validateButton": "Rememes-module-scss-module__xxjSQW__validateButton",
  "verifiedIcon": "Rememes-module-scss-module__xxjSQW__verifiedIcon",
});
